// extracted by mini-css-extract-plugin
export default {"container":"ValueColumn_container__ilGaC","editingValue":"ValueColumn_editingValue__lrkWC","errorModal":"ValueColumn_errorModal__ZmSfO"};